import { Components, Theme } from "@mui/material";

export const muiDrawer: Components<Theme>["MuiDrawer"] = {
  styleOverrides: {
    paper: ({ theme, ownerState }) => ({
      ...(ownerState.variant === "permanent" && {
        boxShadow: theme.shadows[16],
      }),
    }),
  },
};
